import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './MenuIcon.styles';
export function MenuIcon({ isOpen }) {
    return (_jsxs(Icon, Object.assign({ isOpen: isOpen }, { children: [_jsx("span", {}, void 0), _jsx("span", {}, void 0), _jsx("span", {}, void 0)] }), void 0));
}
//# sourceMappingURL=MenuIcon.js.map